import { render, staticRenderFns } from "./researches.vue?vue&type=template&id=4b3922b5&"
import script from "./researches.vue?vue&type=script&lang=js&"
export * from "./researches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports